import React from 'react';
import cn from 'classnames';

// Same seal as react/src/static/images/brand_partner_badge.svg, inlined so the
// shape and check can be colored via the badge-shape / badge-check classes.
const PartnerBadge = ({ className, size = 16, title = 'Brand partner' }) => (
  <svg
    className={cn('partner-badge-icon', className)}
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    role='img'
    aria-label={title}
  >
    <title>{title}</title>
    <path
      className='badge-shape'
      d='M11.293 1.70703C11.6835 1.31661 12.3165 1.31661 12.707 1.70703L14.9287 3.92871C15.1162 4.11621 15.3706 4.22164 15.6357 4.22168H18.7783C19.3306 4.22168 19.7783 4.66939 19.7783 5.22168V8.36426C19.7784 8.62942 19.8838 8.88379 20.0713 9.07129L22.293 11.293C22.6834 11.6835 22.6834 12.3165 22.293 12.707L20.0713 14.9287C19.8838 15.1162 19.7784 15.3706 19.7783 15.6357V18.7783C19.7783 19.3306 19.3306 19.7783 18.7783 19.7783H15.6357C15.3706 19.7784 15.1162 19.8838 14.9287 20.0713L12.707 22.293C12.3165 22.6834 11.6835 22.6834 11.293 22.293L9.07129 20.0713C8.88379 19.8838 8.62942 19.7784 8.36426 19.7783H5.22168C4.66939 19.7783 4.22168 19.3306 4.22168 18.7783V15.6357C4.22164 15.3706 4.11621 15.1162 3.92871 14.9287L1.70703 12.707C1.31661 12.3165 1.31661 11.6835 1.70703 11.293L3.92871 9.07129C4.11621 8.88379 4.22164 8.62942 4.22168 8.36426V5.22168C4.22168 4.66939 4.66939 4.22168 5.22168 4.22168H8.36426C8.62942 4.22164 8.88379 4.11621 9.07129 3.92871L11.293 1.70703Z'
    />
    <path
      className='badge-check'
      d='M16.3535 8.89648C16.1583 8.70122 15.8417 8.70122 15.6465 8.89648L10.75 13.793L8.85352 11.8965C8.65825 11.7012 8.34175 11.7012 8.14648 11.8965C7.95122 12.0917 7.95122 12.4083 8.14648 12.6035L10.3965 14.8535C10.5917 15.0488 10.9083 15.0488 11.1035 14.8535L16.3535 9.60352C16.5488 9.40825 16.5488 9.09175 16.3535 8.89648Z'
    />
  </svg>
);

export default PartnerBadge;
